<script>
import {
  Header as AppHeader,
  SidebarToggler,
  Footer as TheFooter,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
} from '@coreui/vue'
import userdropdown from './../views/dropdowns/userdropdown'
import nav from './../../_nav.js'
import {
  userMethods,
  authComputed,
  userComputed,
  systemSettingsMethods,
  outletMethods,
} from '@state/helpers'

export default {
  components: {
    userdropdown,
    SidebarToggler,
    AppHeader,
    TheFooter,
    AppSidebar,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      user: {},
      nav: nav.items,
      selected: null,
    }
  },
  computed: {
    ...authComputed,
    ...userComputed,
  },
  mounted() {
    this.getUserDetails()
  },
  methods: {
    ...userMethods,
    ...systemSettingsMethods,
    ...outletMethods,
    getUserDetails() {
      return this.fetchUser({
        userId: this.authDetails.userId,
      })
        .then(async currentUser => {
          this.user = currentUser

          switch (window.localStorage.getItem('selectedOutlet')) {
            case undefined:
              window.localStorage.setItem(
                'selectedOutlet',
                this.user.outletIds[0]
              )
              break
            case '':
              window.localStorage.setItem(
                'selectedOutlet',
                this.user.outletIds[0]
              )
              break
            case null:
              window.localStorage.setItem(
                'selectedOutlet',
                this.user.outletIds[0]
              )
              break

            default:
              break
          }

          window.localStorage.setItem('selectedGrpId', this.user.groupId)

          // this.selected = this.user.outletIds[0]
          // this.changeOutlet()

          // this.user.outetIds.foreach(e => {
          //   let res = this.getAllsystemSettings(e)
          //   console.log(res);
          // })
          let inventoryState = false
          let invEnabledOutlets = []
          let weightedAvgOutlets = []
          let oloServiceState = false
          let promotionManagementstate = false
          let promotionOutlets = [] // checks if any outlet is activated inventroy managemnet
          for (let i = 0; i < this.user.outlets.length; i++) {
            let res = await this.getAllsystemSettings(this.user.outlets[i].id)
            // console.log('res', res)
            var inveSt = res.data[0].settings.find(
              x => x.name === 'inventory'
            ).state

            const inveWA = res.data[0].settings.find(x => x.name === 'WAC')

            var oloSt = res.data[0].settings.find(
              x => x.name === 'activateQueue'
            ).state

            const promotionManagement = res.data[0].settings.find(
              x => x.name === 'promotionManagement'
            )
            var promoSt = false
            var inveWASt = false
            if (promotionManagement) {
              promoSt = res.data[0].settings.find(
                x => x.name === 'promotionManagement'
              ).state
            }

            if (inveWA) {
              inveWASt = res.data[0].settings.find(x => x.name === 'WAC').state
            }
            if (inveSt) {
              inventoryState = inveSt
              invEnabledOutlets.push(this.user.outlets[i])
              // console.log(inveSt, this.user.outletIds[i])
            }

            if (oloSt) {
              oloServiceState = oloSt
            }
            if (promoSt) {
              promotionManagementstate = promoSt
              promotionOutlets.push(this.user.outlets[i])
            }
            if (inveWASt) {
              weightedAvgOutlets.push(this.user.outlets[i])
            }
          }

          // let response = await this.getAllsystemSettings(this.user.outletIds[0])
          // if (response.status == 200) {
          //   var inventoryState = response.data[0].settings.find(
          //     x => x.name === 'inventory'
          //   ).state

          window.localStorage.setItem(
            'invEnabledOutlets',
            JSON.stringify(invEnabledOutlets)
          )
          window.localStorage.setItem(
            'promotionOutlets',
            JSON.stringify(promotionOutlets)
          )
          window.localStorage.setItem(
            'weightedAvgOutlets',
            JSON.stringify(weightedAvgOutlets)
          )

          this.nav = nav.items

          if (!inventoryState) {
            for (let i = 0; i < this.nav.length; i++) {
              const data = this.nav[i]
              if (data.name === 'Inventory Master') {
                this.nav.splice(i, 1)
              }
            }
            for (let i = 0; i < this.nav.length; i++) {
              const data = this.nav[i]

              if (data.name === 'Inventory') {
                this.nav.splice(i, 1)
              }
            }
            for (let i = 0; i < this.nav.length; i++) {
              const data = this.nav[i]

              if (data.name === 'Inventory Reports') {
                this.nav.splice(i, 1)
              }
            }
            for (let i = 0; i < this.nav.length; i++) {
              const data = this.nav[i]

              if (data.name === 'Inventory Management') {
                this.nav.splice(i, 1)
              }
            }
          }

          if (!oloServiceState) {
            for (let i = 0; i < this.nav.length; i++) {
              const data = this.nav[i]
              if (data.name === 'OLO') {
                this.nav.splice(i, 1)
              }
            }
          }
          if (!promotionManagementstate) {
            for (let i = 0; i < this.nav.length; i++) {
              const data = this.nav[i]
              if (data.name === 'Promotions') {
                this.nav.splice(i, 1)
              }
            }
          }
          //  }

          let tempOLOstatus = false
          let outletTagInfo = []
          let contact = []
          let logo = ''
          let name = ''
          let currency = ''
          // get all inv outlets in the for the group
          let invEnabledAllOutlets = []
          try {
            let grpRes = await this.getAllOutlets(this.user.groupId) // load group doc
            for (let i = 0; i < grpRes.data[0].outlet_ids.length; i++) {
              let outletRes = await this.getAllOutlets(
                grpRes.data[0].outlet_ids[i]
              )
              let res = await this.getAllsystemSettings(
                grpRes.data[0].outlet_ids[i]
              )
              // console.log('res', res)

              var inveSt = res.data[0].settings.find(
                x => x.name === 'inventory'
              ).state

              if (inveSt) {
                inventoryState = inveSt
                invEnabledAllOutlets.push({
                  id: outletRes.data[0]._id,
                  name: outletRes.data[0].name,
                })
              }
            }

            window.localStorage.setItem(
              'allInvOutlets',
              JSON.stringify(invEnabledAllOutlets)
            )
          } catch (error) {
            console.log(error)
          }
          // grp doc

          window.localStorage.setItem('oloStatus', 'false')
          for (const outlet of this.user.outletIds) {
            let outletRes = await this.getAllOutlets(outlet)
            let tags = []
            logo = outletRes.data[0].print_logo
            name = outletRes.data[0].name
            contact = outletRes.data[0].contact_info
            currency = outletRes.data[0].currency
            if (outletRes.data[0].tags && outletRes.data[0].tags.length > 0) {
              for (const tag of outletRes.data[0].tags) {
                tags.push({
                  tag: tag,
                })
              }
            }

            outletTagInfo.push({
              id: outlet,
              tags: tags,
              contact: contact,
              logo: logo,
              name: name,
              currency: currency,
            })

            window.localStorage.setItem('tags', JSON.stringify(outletTagInfo))

            if (outletRes.status == 200) {
              if (outletRes.data[0].olo !== undefined) {
                if (
                  outletRes.data.find(
                    x =>
                      x.olo.status === true ||
                      x.uber.status === true ||
                      x.pickme.status === true
                  )
                ) {
                  tempOLOstatus = true
                  window.localStorage.setItem('oloStatus', 'true')
                }
              }
            }
          }

          if (tempOLOstatus == false) {
            for (let i = 0; i < this.nav.length; i++) {
              const data = this.nav[i]
              if (data.name === 'OLO') {
                this.nav.splice(i, 1)
              }
            }
          }
        })
        .catch(error => {
          return error
        })
    },

    changeOutlet() {
      // introduce UI loaders here for future
      // copy this method and the select to any page we need the outlet selector
      this.setSelectedOutlet({ outlet: this.selected })
        .then(outletInfo => {
          return outletInfo
        })
        .catch(error => {
          return error
        })
    },
  },
}
</script>

<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-link class="navbar-brand" to="/dashboard">
        <img
          src="../../assets/images/omaklogo.png"
          style="width: 95px; height: 25px"
        />
      </b-link>
      <b-navbar-nav class="ml-auto">
        <!-- <select
          v-model="selected"
          name="LeaveType"
          class="form-control"
          @change="changeOutlet()"
        >
          <option
            v-for="(option, index) in user.outletIds"
            :key="index"
          >
            {{ option }}
          </option>
        </select>-->
        <p class="username">
          {{ this.user.firstName }} {{ this.user.lastName }}
        </p>
        <userdropdown />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :nav-items="nav" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <div class="main">
        <div class="container-fluid main-container">
          <slot />
        </div>
      </div>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="http://www.omak.co">OMAK POS 4</a>
        <span class="ml-1">&copy; 2022 OMAK Technologies (Pvt) Ltd.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="http://www.omak.co">OMAK</a>
      </div>
    </TheFooter>
  </div>
</template>

<style scoped>
/* stylelint-disable-next-line selector-class-pattern */
.main-container {
  padding-top: 24px;
}

.username {
  padding-top: 10px;
  margin-bottom: 10px;
}

.sidebar .nav {
  width: 250px !important;
}

.sidebar .sidebar-nav {
  width: 250px !important;
}

.sidebar {
  width: 250px !important;
}

.sidebar-nav {
  width: 250px !important;
}
</style>

<style>
.sidebar .nav {
  width: 250px !important;
}

.sidebar .sidebar-nav {
  width: 250px !important;
}

.sidebar {
  width: 250px !important;
}

html:not([dir='rtl']) .sidebar {
  margin-left: -250px;
}

.sidebar-nav {
  width: 250px !important;
}

.sidebar .nav-dropdown.open .nav-link {
  font-size: 15px;
}

.main .container-fluid {
  padding: 0 55px;
  padding-top: 24px;
}
</style>
